var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "footer-button",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.visitLanding.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "20px",
            height: "20px",
            viewBox: "0 0 17 17",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Search-/-Explore",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Main---New-Nav",
                    transform: "translate(-29.000000, -748.000000)",
                    stroke: "#000000",
                    "stroke-width": "1.2"
                  }
                },
                [
                  _c("polygon", {
                    attrs: {
                      id: "Path-2",
                      points:
                        "30 764 45 764 45 753.722498 37.5 749 30 753.722498"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Home")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12391508", { render: render, staticRenderFns: staticRenderFns })
  }
}